export default "__VITE_ASSET__CFSkcjEY__"